// Shared "show this once" flag for the talent-side hints (Welcome popup,
// star hint, first-upload popup). Per device via localStorage, but with a
// 7-day expiry (2026-09-15): a talent who returns after weeks with a fresh
// session should get the hints again, while a regular who does several
// projects a week is not nagged on every one. Storing the flags in the
// session record instead was rejected — that would re-show everything on
// every new project, and talents have no cross-device identity anyway.
//
// Value = ms timestamp of the click that dismissed the hint. The legacy
// value "1" (pre-expiry builds) is migrated to "seen now" on first read so
// the deploy doesn't re-show all three hints to every current device.
// Blocked storage (private mode) counts as seen — never nag.

export const ONCE_FLAG_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function defaultStorage(): Storage {
  return window.localStorage;
}

export function hasSeenOnceFlag(key: string, storage?: Storage, now = Date.now()): boolean {
  try {
    const st = storage ?? defaultStorage();
    const raw = st.getItem(key);
    if (raw === null) return false;
    if (raw === '1') {
      // Legacy boolean flag → start the 7-day clock now.
      st.setItem(key, String(now));
      return true;
    }
    const seenAt = Number(raw);
    if (!Number.isFinite(seenAt)) return false;
    return now - seenAt <= ONCE_FLAG_TTL_MS;
  } catch {
    return true;
  }
}

export function markOnceFlagSeen(key: string, storage?: Storage, now = Date.now()): void {
  try {
    (storage ?? defaultStorage()).setItem(key, String(now));
  } catch {
    /* storage blocked — the hint simply shows again next time */
  }
}
